'use client';

import { ReactNode } from 'react';

import { useMediaQuery } from '@personly/libs-hooks';

interface Props {
  children: ReactNode;
}

const MobileHidden = ({ children }: Props) => {
  const isLessThanSm = useMediaQuery('(max-width: 640px)', false);

  return !isLessThanSm && children;
};

export default MobileHidden;
